import { inject, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Pipe({
  name: 'refLinkParams',
})
export class RefLinkParamsPipe implements PipeTransform {

  private readonly activatedRoute = inject(ActivatedRoute);

  public transform(ref: string | number): (string | number)[] {
    return [
      ...this.activatedRoute.snapshot.queryParamMap.getAll('ref'),
      ref,
    ];
  }

}
